module.exports = __webpack_public_path__ + "img/laibin.5653b1ea.png";